import { gql } from '@apollo/client'

const GET_ONE_REQUEST = gql`
  query getOneMyRequests($idRequest: UUID!) {
    request(id: $idRequest) {
      requestAddress
      location {
        x
        y
      }
      summary
      title
      datetimeRange {
        end {
          value
        }
        start {
          value
        }
      }
      watcherByIdWatcher {
        addressLine1
        addressLine2
      }
    }
  }
`
export default GET_ONE_REQUEST
